"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderHook = exports.TestHookWrapper = exports.HookWrapper = void 0;
var react_1 = __importDefault(require("react"));
var enzyme_1 = require("enzyme");
function HookWrapper(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.HookWrapper = HookWrapper;
;
function TestHookWrapper(hookFn, ref) {
    return function () {
        var hookArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            hookArgs[_i] = arguments[_i];
        }
        return function () {
            var hookStates = hookFn.apply(void 0, hookArgs);
            if (ref) {
                ref.current = hookStates;
            }
            ;
            return (react_1.default.createElement(HookWrapper, { hook: hookStates, hookWrapperRef: ref }));
        };
    };
}
exports.TestHookWrapper = TestHookWrapper;
function renderHook(hookFn, Wrapper) {
    return function () {
        var hookArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            hookArgs[_i] = arguments[_i];
        }
        var ref = { current: {} };
        var Hook = TestHookWrapper(hookFn, ref).apply(void 0, hookArgs);
        if (Wrapper) {
            enzyme_1.mount(react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(Hook, null)));
        }
        else {
            enzyme_1.shallow(react_1.default.createElement(Hook, null));
        }
        return ref;
    };
}
exports.renderHook = renderHook;
